export const GET_PRODUCTS_REQUEST = "GET_PRODUCTS_REQUEST";

export const GET_PRODUCTS_SUCCCESS = "GET_PRODUCTS_SCCCESS";

export const GET_PRODUCTS_ERROR = "GET_PRODUCTS_ERROR";
